import {
  leagueCustomerFinancialEntityApplyChargeRoute,
  leagueCustomerFinancialEntityIndividualApplyChargeRoute,
  leagueCustomerFinancialEntityBalanceRoute,
  leagueCustomerFinancialEntityIndividualBalanceRoute,
  leagueCustomerFinancialEntityDebtsRoute,
  leagueCustomerFinancialEntityIndividualDebtsRoute,
  leagueCustomerFinancialEntityIndividualInvoicesRoute,
  leagueCustomerFinancialEntityIndividualPaymentLinksRoute,
  leagueCustomerFinancialEntityIndividualRegisterAddBalanceRoute,
  leagueCustomerFinancialEntityIndividualRegisterInvoicesPaymentRoute,
  leagueCustomerFinancialEntityIndividualVoidInvoicesRoute,
  leagueCustomerFinancialEntityInvoicesRoute,
  leagueCustomerFinancialEntityPaymentLinksRoute,
  leagueCustomerFinancialEntityRegisterAddBalanceRoute,
  leagueCustomerFinancialEntityRegisterInvoicesPaymentRoute,
  leagueCustomerFinancialEntityVoidInvoicesRoute,
} from "network/api-routes";

export const accountFinanceRoutes = (customerId, account) => {
  if (account.type === "individual") {
    return {
      balance: leagueCustomerFinancialEntityIndividualBalanceRoute(
        customerId,
        account.entityId,
        account.individualId,
      ),
      invoices: leagueCustomerFinancialEntityIndividualInvoicesRoute(
        customerId,
        account.entityId,
        account.individualId,
      ),
      debts: leagueCustomerFinancialEntityIndividualDebtsRoute(
        customerId,
        account.entityId,
        account.individualId,
      ),
      invoicePayments: leagueCustomerFinancialEntityIndividualRegisterInvoicesPaymentRoute(
        customerId,
        account.entityId,
        account.individualId,
      ),
      paymentLinks: leagueCustomerFinancialEntityIndividualPaymentLinksRoute(
        customerId,
        account.entityId,
        account.individualId,
      ),
      addBalance: leagueCustomerFinancialEntityIndividualRegisterAddBalanceRoute(
        customerId,
        account.entityId,
        account.individualId,
      ),
      voidInvoices: leagueCustomerFinancialEntityIndividualVoidInvoicesRoute(
        customerId,
        account.entityId,
        account.individualId,
      ),
    };
  }

  return {
    balance: leagueCustomerFinancialEntityBalanceRoute(customerId, account.entityId),
    invoices: leagueCustomerFinancialEntityInvoicesRoute(customerId, account.entityId),
    debts: leagueCustomerFinancialEntityDebtsRoute(customerId, account.entityId),
    invoicePayments: leagueCustomerFinancialEntityRegisterInvoicesPaymentRoute(customerId, account.entityId),
    paymentLinks: leagueCustomerFinancialEntityPaymentLinksRoute(customerId, account.entityId),
    addBalance: leagueCustomerFinancialEntityRegisterAddBalanceRoute(customerId, account.entityId),
    voidInvoices: leagueCustomerFinancialEntityVoidInvoicesRoute(customerId, account.entityId),
  };
};

export const accountApplyChargeRoute = (customerId, account, templateId) =>
  account.type === "individual"
    ? leagueCustomerFinancialEntityIndividualApplyChargeRoute(
        customerId,
        account.entityId,
        account.individualId,
        templateId,
      )
    : leagueCustomerFinancialEntityApplyChargeRoute(customerId, account.entityId, templateId);
